import { SVGProps } from 'react';

export const OpenGateIcon = (props: SVGProps<SVGSVGElement>) => {
	const color = props.color ?? '#BEBEBE';
	return (
		<svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M15 7C15 6.44772 15.4477 6 16 6H17C17.5523 6 18 6.44772 18 7V20H15V7Z'
				stroke={color}
				strokeWidth='1.38'
			/>
			<path d='M13 20H20' stroke={color} strokeWidth='1.38' strokeLinecap='round' />
			<path
				d='M15.0021 12.5482L1.86603 4.9641C1.38773 4.68796 1.22386 4.07637 1.5 3.59808L2.5 1.86603C2.77614 1.38773 3.38773 1.22386 3.86603 1.5L15.0021 7.9294'
				stroke={color}
				strokeWidth='1.38'
			/>
			<path d='M2.73193 5.4641L8.19604 4' stroke={color} strokeWidth='1.38' strokeLinecap='round' />
			<path d='M7.92822 8.4641L13.3923 7' stroke={color} strokeWidth='1.38' strokeLinecap='round' />
		</svg>
	);
};
